import {
  defaultSystemCode,
  defaultTrader,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  Trader,
  TraderFromJSON
} from '@/api'

export interface Budget {
  id: number
  year: string
  branchCode: SystemCode
  departmentCode: SystemCode
  item: SystemCode
  equipType: SystemCode
  traderCode: Trader
  price: number
  orderPrice: number
  acceptPrice: number
  revision: number
}

export function BudgetFromJSON(json: any): Budget {
  return {
    id: exists(json, 'id') ? json.id : 0,
    year: exists(json, 'year') ? json.year : '',
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    departmentCode: exists(json, 'department_code')
      ? SystemCodeFromJSON(json.department_code)
      : defaultSystemCode(),
    item: exists(json, 'item')
      ? SystemCodeFromJSON(json.item)
      : defaultSystemCode(),
    equipType: exists(json, 'equip_type')
      ? SystemCodeFromJSON(json.equip_type)
      : defaultSystemCode(),
    traderCode: exists(json, 'trader_code')
      ? TraderFromJSON(json.trader_code)
      : defaultTrader(),
    price: exists(json, 'price') ? json.price : 0,
    orderPrice: exists(json, 'order_price') ? json.order_price : 0,
    acceptPrice: exists(json, 'accept_price') ? json.accept_price : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
